var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddTreatment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#005ADC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 13.3337C24.1084 13.3337 24.4958 13.3337 24.8138 13.4188C25.6765 13.65 26.3504 14.3239 26.5815 15.1866C26.6667 15.5045 26.6667 15.892 26.6667 16.667V24.3337C26.6667 25.7338 26.6667 26.4339 26.3942 26.9686C26.1545 27.439 25.7721 27.8215 25.3017 28.0612C24.7669 28.3337 24.0668 28.3337 22.6667 28.3337H17.3334C15.9332 28.3337 15.2332 28.3337 14.6984 28.0612C14.228 27.8215 13.8455 27.439 13.6059 26.9686C13.3334 26.4339 13.3334 25.7338 13.3334 24.3337V16.667C13.3334 15.892 13.3334 15.5045 13.4186 15.1866C13.6497 14.3239 14.3236 13.65 15.1863 13.4188C15.5042 13.3337 15.8917 13.3337 16.6667 13.3337M20 24.167V19.167M17.5 21.667H22.5M18 15.0003H22C22.4668 15.0003 22.7001 15.0003 22.8784 14.9095C23.0352 14.8296 23.1627 14.7021 23.2425 14.5453C23.3334 14.3671 23.3334 14.1337 23.3334 13.667V13.0003C23.3334 12.5336 23.3334 12.3003 23.2425 12.122C23.1627 11.9652 23.0352 11.8377 22.8784 11.7578C22.7001 11.667 22.4668 11.667 22 11.667H18C17.5333 11.667 17.3 11.667 17.1217 11.7578C16.9649 11.8377 16.8374 11.9652 16.7575 12.122C16.6667 12.3003 16.6667 12.5336 16.6667 13.0003V13.667C16.6667 14.1337 16.6667 14.3671 16.7575 14.5453C16.8374 14.7021 16.9649 14.8296 17.1217 14.9095C17.3 15.0003 17.5333 15.0003 18 15.0003Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTreatment);
export default __webpack_public_path__ + "static/media/add-treatment.86022c3d9a12fc33926f25bf26a1b1c1.svg";
export { ForwardRef as ReactComponent };